// extracted by css-extract-rspack-plugin
export default {"cls1":"Accordion-cls1_LYF","cls2":"Accordion-cls2_8N8 Accordion-cls1_LYF"};